import type { IdentityContext, OrganizationRepository } from '@zetyar/data-contracts'
import { createSupabaseOrganizationRepository } from '@zetyar/supabase-client'
import { getSupabaseClient } from '@/infrastructure/supabase/app'

export const webOrganizationRepository: OrganizationRepository = createSupabaseOrganizationRepository(getSupabaseClient())

export function createWebIdentityContext(input: {
  readonly authUid: string
  readonly personId: string
}): IdentityContext {
  return input
}
